import { render, staticRenderFns } from "./TSDetailModal.vue?vue&type=template&id=0854965a&scoped=true&"
import script from "./TSDetailModal.vue?vue&type=script&lang=js&"
export * from "./TSDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TSDetailModal.vue?vue&type=style&index=0&id=0854965a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854965a",
  null
  
)

export default component.exports